import { action, computed, observable, toJS, runInAction } from "mobx";
import moment from "moment";
import { noBranchSelectedBranch } from "../constants/constants-container";
import localStorage from "mobx-localstorage";

const showClosedProjectsForPoLocalStorageKey = "show-closed-projects-for-po";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class ProjectOwnerStore {
  constructor(http, contentManagementStore, exporter) {
    this.http = http;
    this.contentManagementStore = contentManagementStore;
    this.exporter = exporter;
  }

  @observable bool_showModal = false;

  @observable bool_add_da_modal_visibility = false;

  @observable
  ob_fetched_po_ma_data = {
    maintenanceAgencies: [],
  };

  @observable selectedProjectTid = null;

  @observable obj_selected_project = {
    dictionaryAdministratorsWithBranches: [],
    finalRelease: {},
    framework: {},
    frameworks: [],
    intermediateReleases: [],
    maintenanceAgency: {},
    maintenanceAgencyOwners: [],
    masterBranch: {},
    project: {},
    projectMembers: [],
    projectOwners: [],
  };

  @observable
  obj_releaseBuildModalData = {
    name: "",
    description: "",
    pid: "",
    releaseType: "",
  };

  @observable arr_allUsers = [];

  @observable showClosedProjects =
    localStorage.getItem(showClosedProjectsForPoLocalStorageKey) !== undefined
      ? localStorage.getItem(showClosedProjectsForPoLocalStorageKey)
      : false;

  @observable
  shouldCloseProjectOnPromote = true;

  @action
  activation_PoStore = () => {
    this.helper_fetch_po_data();
  };

  @action("merge po branch with selected master branch")
  action_merge_branch_With_masterB = (branch_entity) => {
    if (IS_BIRD_APP) return;

    const branch_tid = branch_entity.branch.tid;
    const masterBranch_tid = this.obj_selected_project.masterBranch.tid;

    const o_merge_conf = {
      actionType: "MergeBranch",
      sourceBid: branch_tid,
      targetBid: masterBranch_tid,
    };

    runInAction(() => {
      this.http.func_sendGeneralMessage(o_merge_conf, (response) => {
        this.o_alert_data = response;

        // dirty way to reset the branch selector
        const { cm_computed_o_selectedBranch } = this.contentManagementStore;
        if (branch_tid === cm_computed_o_selectedBranch.bid) {
          this.contentManagementStore.switchBranch(
            noBranchSelectedBranch,
            () => {
              window.localStorage.setItem(
                "cm-selected-branch",
                JSON.stringify(noBranchSelectedBranch)
              );
            }
          );
        }
      });
    });
  };

  @action
  func_setReleaseType = (releaseType) => {
    this.obj_releaseBuildModalData = {
      ...this.obj_releaseBuildModalData,
      releaseType: releaseType,
    };
  };

  @action
  action_select_toggle_project_helper = (projectData) => {
    this.obj_releaseBuildModalData = {
      ...this.obj_releaseBuildModalData,
      pid: projectData.project.tid,
    };
  };

  @action
  func_handleReleaseNameChange = (name) => {
    this.obj_releaseBuildModalData = {
      ...this.obj_releaseBuildModalData,
      name: name,
    };
  };

  @action
  func_handleReleaseDescriptionChange = (description) => {
    this.obj_releaseBuildModalData = {
      ...this.obj_releaseBuildModalData,
      description: description,
    };
  };

  @action
  func_toggleShowReleaseBuildModal = () => {
    this.bool_showModal = !this.bool_showModal;
    this.func_resetReleaseBuildModalData();
  };

  @action
  func_resetReleaseBuildModalData = () => {
    this.obj_releaseBuildModalData = {
      ...this.obj_releaseBuildModalData,
      title: "",
      version: "",
    };
  };

  @action
  func_sendRequest = (jsonToSend, callback) => {
    if (IS_BIRD_APP) return;

    runInAction(() => {
      this.http.func_sendGeneralMessage(jsonToSend, (response) => {
        if (
          response &&
          response.resultType &&
          response.resultType === "SUCCESS" &&
          callback
        ) {
          callback();
        }
      });
    });
  };

  @action
  service_create_json() {
    // Declaring variables
    const { pid, name, description, releaseType } =
      this.obj_releaseBuildModalData;
    const { tid } = this.computed_dataModel_for_menu[0].projects[0].project;

    let jsonToSend = {};

    jsonToSend.actionType = "BuildRelease";
    jsonToSend.pid = pid !== "" ? pid : tid;

    jsonToSend.name = name;
    jsonToSend.description = description;
    jsonToSend.releaseType = releaseType.toUpperCase();

    return jsonToSend;
  }

  @action
  func_build = () => {
    let jsonToSend = this.service_create_json();
    this.func_sendRequest(jsonToSend);
  };

  @action
  promoteMasterBranchContentToProduction = () => {
    if (IS_BIRD_APP) return;

    const payload = {
      actionType: "PromoteProject",
      pid: this.get_obj_selected_project.project.tid,
      shouldCloseProjectOnPromote: this.shouldCloseProjectOnPromote,
    };
    this.http.func_sendGeneralMessage(payload);
  };

  @action("change finalization date in select project")
  action_change_finalizationDatePO = (e_selected_date, selected_project) => {
    if (IS_BIRD_APP) return;

    const isoDate = e_selected_date.toISOString().split("T")[0];
    const new_finalizationDate = moment(isoDate).format("YYYY-MM-DD");
    const {
      tid,
      mid,
      name,
      description,
      projectType,
      isNonFrameworkType,
      status,
      creationDate,
      type,
      isFastTrack,
      areBusinessConstraintsDisabled,
    } = selected_project.project;

    const conf_updateFinalDate = {
      actionType: "UpdateOrchestration",
      orchestration: {
        tid: tid,
        mid: mid,
        name: name,
        description: description,
        projectType: projectType,
        isNonFrameworkType: isNonFrameworkType,
        status: status,
        creationDate: creationDate,
        finalizationDate: new_finalizationDate,
        type: type,
        // framework is framework's tid
        framework: selected_project.framework
          ? selected_project.framework.tid
          : null,
        frameworks: selected_project.frameworks
          ? selected_project.frameworks
              .map((framework) => framework.tid)
              .join(", ")
          : null,
        isFastTrack: isFastTrack,
        areBusinessConstraintsDisabled: areBusinessConstraintsDisabled
      },
    };

    runInAction(() => {
      this.http.func_sendGeneralMessage(conf_updateFinalDate, (response) => {
        this.o_alert_data = response;
      });
    });
  };

  @computed
  get get_bool_showModal() {
    return toJS(this.bool_showModal);
  }

  @action
  action_add_DA_toPro = (new_da) => {
    if (IS_BIRD_APP) return;

    const da_aid = new_da;
    // const num_project_id = this.obj_selected_project.project.tid;

    const {
      project: { tid },
    } = this.obj_selected_project;

    const ob_add_da_config = {
      actionType: "AddDictionaryAdministrator",
      pid: tid,
      aid: da_aid,
    };

    runInAction(() => {
      this.http.func_sendGeneralMessage(ob_add_da_config, (response) => {});
    });
  };

  @action
  action_delete_da = (ob_da_info) => {
    if (IS_BIRD_APP) return;

    const num_da_tid = ob_da_info.dictionaryAdministrator.tid;

    const {
      project: { tid },
    } = this.obj_selected_project;

    const obj_del_config = {
      actionType: "RemoveDictionaryAdministrator",

      pid: tid,
      aid: num_da_tid,
    };

    runInAction(() => {
      this.http.func_sendGeneralMessage(obj_del_config, (response) => {
        this.o_alert_data = response;
      });
    });
  };

  @action
  helper_fetch_po_data = () => {
    if (IS_BIRD_APP) return;

    const helper_map_loop_ma = (ma, maIndex) => {
      return {
        ...ma,
        visibility: this.doesMaContainProject(ma, this.selectedProjectTid),
        projects: ma.projects.map((project, projectIndex) => ({
          ...project,
          visibility: project.project.tid === this.selectedProjectTid,
        })),
      };
    };

    this.http.service_fetch_po_data().then(
      action((obj_po_dataModel) => {
        try {
          this.ob_fetched_po_ma_data = {
            maintenanceAgencies:
              obj_po_dataModel.maintenanceAgencies.map(helper_map_loop_ma),
          };
          this.action_selectProjectView(this.selectedProjectTid);
        } catch (error) {
          console.error(error.message);
          this.ob_fetched_po_ma_data.maintenanceAgencies = [];
        }
      })
    );
  };

  doesMaContainProject = (maintenanceAgency, projectTid) => {
    for (let i = 0; i < maintenanceAgency.projects.length; i++) {
      if (maintenanceAgency.projects[i].project.tid === projectTid) {
        return true;
      }
    }
    return false;
  };

  @action
  action_selectProjectView = (selectedProjectTid) => {
    this.selectedProjectTid = selectedProjectTid;
    for (
      let i = 0;
      i < this.ob_fetched_po_ma_data.maintenanceAgencies.length;
      i++
    ) {
      for (
        let j = 0;
        j < this.ob_fetched_po_ma_data.maintenanceAgencies[i].projects.length;
        j++
      ) {
        if (
          this.ob_fetched_po_ma_data.maintenanceAgencies[i].projects[j].project
            .tid === selectedProjectTid
        ) {
          this.obj_selected_project =
            this.ob_fetched_po_ma_data.maintenanceAgencies[i].projects[j];
          break;
        }
      }
    }

    this.action_select_toggle_project_helper(this.obj_selected_project);

    this.ob_fetched_po_ma_data = {
      maintenanceAgencies: this.ob_fetched_po_ma_data.maintenanceAgencies.map(
        (ma, maIndex) => {
          if (this.doesMaContainProject(ma, selectedProjectTid)) {
            return {
              ...ma,
              visibility: true,
              projects: ma.projects.map((project, projectIndex) => {
                return {
                  ...project,
                  visibility: project.project.tid === selectedProjectTid,
                };
              }),
            };
          } else {
            return {
              ...ma,
              visibility: false,
            };
          }
        }
      ),
    };
  };

  @action
  reopenSelectedProject = () => {
    if (IS_BIRD_APP) return;

    const { tid } = this.obj_selected_project.project;
    const json = {
      actionType: "ReopenProject",
      pid: tid,
    };
    this.http.func_sendGeneralMessage(json);
  };

  @action
  closeSelectedProject = () => {
    if (IS_BIRD_APP) return;

    const { tid } = this.obj_selected_project.project;
    const json = {
      actionType: "CloseProject",
      pid: tid,
    };
    this.http.func_sendGeneralMessage(json);
  };

  @action
  toggleShowClosedProjectsForPo = () => {
    this.showClosedProjects = !this.showClosedProjects;
    localStorage.setItem(
      showClosedProjectsForPoLocalStorageKey,
      this.showClosedProjects
    );
  };

  exportChangesInFrameworkInProduction = () => {
    this.exporter.exportLatestProductionChangelog(
      this.obj_selected_project.frameworks
    );
  };

  @computed
  get getShowClosedProjectsForPo() {
    return this.showClosedProjects;
  }

  @computed
  get computed_dataModel_for_menu() {
    return this.ob_fetched_po_ma_data.maintenanceAgencies;
  }

  @computed
  get getFrameworkTidsWhereActorIsPoOfProjectRelatedToFramework() {
    const { maintenanceAgencies } = this.ob_fetched_po_ma_data;
    if (maintenanceAgencies.length === 0) {
      return [];
    }
    let frameworkTids = [];
    for (let ma of maintenanceAgencies) {
      for (let project of ma.projects) {
        if (project.frameworks) {
          const frameworks = project.frameworks.filter(
            (it) => it.type === "Framework"
          );
          frameworks.length > 0 &&
            frameworkTids.push(frameworks.map((it) => it.tid));
        }
      }
    }
    return frameworkTids.flatMap((tid) => tid);
  }

  @computed
  get get_selected_maintenanceAgencyName() {
    const { mid } = this.get_selected_project.project;

    const arr_filteredMaintenanceAgency = this.get_arr_all_MA.filter((ma) => {
      return Number(ma.maintenanceAgency.tid) === Number(mid);
    });

    return arr_filteredMaintenanceAgency[0].maintenanceAgency.name;
  }

  @computed
  get get_obj_releaseBuildModalData() {
    return this.obj_releaseBuildModalData;
  }

  @computed
  get get_arr_tableData() {
    return this.arr_tableData;
  }

  @computed
  get get_obj_selected_project() {
    return this.obj_selected_project;
  }

  @computed
  get po_computed_a_all_employee() {
    const users = this.arr_allUsers.map((user) => {
      return {
        label: user.name,
        value: user.tid,
      };
    });
    return users;
  }

  toggleShouldCloseProjectOnPromote = () => {
    this.shouldCloseProjectOnPromote = !this.shouldCloseProjectOnPromote;
  }
}
